import { useCallback } from 'react'
import { toggleField } from '@user/components/Settings/PendingLeadSettings/helpers'
import type { IAutoReviewAdditionalField } from '@user/store/autoReviewSettings'
import type { UseData } from './useData'

type Props = {
  onAdd: (selection: IAutoReviewAdditionalField[]) => void
}

export const useHandlers = (data: UseData, props: Props) => {
  const { picks, setPicks } = data
  const { onAdd } = props

  const handleToggle = useCallback(
    (field: IAutoReviewAdditionalField) => () =>
      setPicks((prev) => toggleField(prev, field)),
    [setPicks],
  )

  const handleSubmit = useCallback(() => onAdd(picks), [onAdd, picks])

  return { handleToggle, handleSubmit }
}
